export default __webpack_public_path__ + "static/media/eth-xnft.085d790b.svg";